import React, { useState } from "react";
import { useParams } from "react-router-dom";
import HelpSearch from "../help/help-search";
import ThumbsDown from "../icons/ThumbsDown.svg";
import ThumbsUp from "../icons/ThumbsUp.svg";
import ThumbsUp_selected from "../icons/ThumbsUp_selected.svg";
import ThumbsDown_selected from "../icons/ThumbsDown_selected.svg";
import Subtract from "../icons/Subtract.svg";
import "../help/help.scss";
import { useCommonContext } from "../../context/common-context";
import { BreadCrumb } from "../../common/breadcrumb";
import { routes, routeTitle } from "../help/constants";
import { getBannerDisplayName, substituteBanner } from "../../../helpers/banner";

const FaqDetail = ({}) => {
  const {
    bannerCategories,
    bannerFAQ,
    appData: { banner: bannerName },
    isGuest,
    isFeedbackAllowed,
  } = useCommonContext();
  const [feedbackStatus, setFeedbackStatus] = useState(false);
  const [selectedType, setSelectedType] = useState(null);
  const params = useParams();
  const { id: paramVal, questionid } = params; // TODO:: tobe handle from api
  const routeTitleKey = routeTitle[paramVal];
  const { id } = bannerCategories.find(({ title }) => title === routeTitleKey);
  const selectedFaq = bannerFAQ.find((list) => {
    return list.id == questionid;
  });

  const banner = getBannerDisplayName(bannerName);

  const faqQuestion = substituteBanner(selectedFaq.question, bannerName);
  const faqAnswer = substituteBanner(selectedFaq.answer, bannerName);
  const {
    title,
    link: { href },
  } = bannerCategories.find((list) => {
    return list.id.toString() == id;
  });
  const updatedTitle = title.replace(/{banner}/g, banner);
  const breadCrumblist = [
    {
      label: "Contact Us",
      href: "/help/home",
    },
    {
      label: "All FAQs",
      href,
    },
    {
      label: `Answers to your ${updatedTitle} `,
    },
  ];

  const handleFaqAction = (type) => {
    setSelectedType(type);
    if (AB && AB.DATALAYER) {
      AB.DATALAYER.setLinkClickEvents(`OHC|thumbs-${type}`);
    }

    setTimeout(() => {
      setFeedbackStatus(true);
      setTimeout(() => {
        setFeedbackStatus(false);
        setSelectedType(null);
      }, 5000);
    }, 1000);
  };

  return (
    <div className="help-wrapper">
      <BreadCrumb list={breadCrumblist} />
      <HelpSearch isGuest={isGuest} banner={banner} />
      <h2 className="font-size-32" aria-label={faqQuestion}>
        {faqQuestion}
      </h2>
      <span
        aria-label={faqAnswer}
        className={"font-weight-normal category-anchor"}
        dangerouslySetInnerHTML={{ __html: faqAnswer }}
      ></span>
      <div className="text-center pt-5 position-relative">
        {!feedbackStatus && (
          <div>
            <h5 className="font-weight-bold">Was this information helpful?</h5>
            <button
              aria-label="Was this information helpful? - thumbs up image graphic yes button"
              title="Yes"
              onClick={() => handleFaqAction("up")}
              className="mr-5 thumb-btn"
              role="button"
            >
              {selectedType != "up" && (
                <img
                  alt="Thumbsup Image"
                  className="mb-2 mx-1"
                  src={ThumbsUp}
                />
              )}
              {selectedType == "up" && (
                <img
                  alt="Thumbsup Image"
                  className="mb-2 mx-1"
                  src={ThumbsUp_selected}
                />
              )}
              Yes
            </button>
            <button
              aria-label="Was this information helpful? - thumbs down image graphic no button"
              title="No"
              className="thumb-btn"
              onClick={() => handleFaqAction("down")}
              role="button"
            >
              {selectedType != "down" && (
                <img
                  alt="Thumbsdown Image"
                  className="mb-2 mx-1"
                  src={ThumbsDown}
                />
              )}
              {selectedType == "down" && (
                <img
                  alt="Thumbsdown Image"
                  className="mb-2 mx-1"
                  src={ThumbsDown_selected}
                />
              )}
              No
            </button>
          </div>
        )}

        {feedbackStatus && (
          <h5 className="font-weight-bold">
            <img alt="Right tick Image" src={Subtract} /> Thank you for
            submitting your feedback!
          </h5>
        )}
        {isFeedbackAllowed && <div className="col-lg-6 col-md-6 col-sm-12 mb-4 mx-auto">
          <a href="https://forms.office.com/r/emAvYmfhay" className="feedback-button" target="_black">
          <button type="button" className="btn btn-block feedback-btn rounded-pill h-100 font-weight-600">Got more feedback? We want to know.</button>
        </a></div>}
      </div>
    </div>
  );
};

export default FaqDetail;
